export interface ConsentProvider {
  initialize(): Promise<boolean>;
  hasConsent(): boolean;
  requestConsent(): Promise<boolean>;
}

const alwaysConsented: ConsentProvider = {
  initialize: async () => true,
  hasConsent: () => true,
  requestConsent: async () => true,
};

let consentProvider: ConsentProvider = alwaysConsented;

export function getConsent(): ConsentProvider {
  return consentProvider;
}

export function configureConsent(provider: ConsentProvider): void {
  consentProvider = provider;
}
